/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as VerifyIndexRouteImport } from './routes/verify.index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as MarketingIndexRouteImport } from './routes/_marketing.index'
import { Route as WorkPublicWorkIdRouteImport } from './routes/work.$publicWorkId'
import { Route as VerifyTagTokenRouteImport } from './routes/verify.$tagToken'
import { Route as ProofProofTokenRouteImport } from './routes/proof.$proofToken'
import { Route as InviteInvitationTokenRouteImport } from './routes/invite.$invitationToken'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppProfileRouteImport } from './routes/app.profile'
import { Route as MarketingSecurityRouteImport } from './routes/_marketing.security'
import { Route as MarketingPricingRouteImport } from './routes/_marketing.pricing'
import { Route as MarketingForGalleriesRouteImport } from './routes/_marketing.for-galleries'
import { Route as MarketingForAuctionHousesRouteImport } from './routes/_marketing.for-auction-houses'
import { Route as MarketingForArtistsRouteImport } from './routes/_marketing.for-artists'
import { Route as MarketingFaqRouteImport } from './routes/_marketing.faq'
import { Route as MarketingAboutRouteImport } from './routes/_marketing.about'
import { Route as AppWorksIndexRouteImport } from './routes/app.works.index'
import { Route as AppTransfersIndexRouteImport } from './routes/app.transfers.index'
import { Route as AppWorksRegisterRouteImport } from './routes/app.works.register'
import { Route as AppWorksWorkIdRouteImport } from './routes/app.works.$workId'
import { Route as MarketingLegalTermsRouteImport } from './routes/_marketing.legal.terms'
import { Route as MarketingLegalPrivacyRouteImport } from './routes/_marketing.legal.privacy'
import { Route as AppWorksWorkIdTransferRouteImport } from './routes/app.works.$workId.transfer'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyIndexRoute = VerifyIndexRouteImport.update({
  id: '/verify/',
  path: '/verify/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const WorkPublicWorkIdRoute = WorkPublicWorkIdRouteImport.update({
  id: '/work/$publicWorkId',
  path: '/work/$publicWorkId',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyTagTokenRoute = VerifyTagTokenRouteImport.update({
  id: '/verify/$tagToken',
  path: '/verify/$tagToken',
  getParentRoute: () => rootRouteImport,
} as any)
const ProofProofTokenRoute = ProofProofTokenRouteImport.update({
  id: '/proof/$proofToken',
  path: '/proof/$proofToken',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInvitationTokenRoute = InviteInvitationTokenRouteImport.update({
  id: '/invite/$invitationToken',
  path: '/invite/$invitationToken',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const MarketingSecurityRoute = MarketingSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPricingRoute = MarketingPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingForGalleriesRoute = MarketingForGalleriesRouteImport.update({
  id: '/for-galleries',
  path: '/for-galleries',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingForAuctionHousesRoute =
  MarketingForAuctionHousesRouteImport.update({
    id: '/for-auction-houses',
    path: '/for-auction-houses',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingForArtistsRoute = MarketingForArtistsRouteImport.update({
  id: '/for-artists',
  path: '/for-artists',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingFaqRoute = MarketingFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingAboutRoute = MarketingAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => MarketingRoute,
} as any)
const AppWorksIndexRoute = AppWorksIndexRouteImport.update({
  id: '/works/',
  path: '/works/',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersIndexRoute = AppTransfersIndexRouteImport.update({
  id: '/transfers/',
  path: '/transfers/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorksRegisterRoute = AppWorksRegisterRouteImport.update({
  id: '/works/register',
  path: '/works/register',
  getParentRoute: () => AppRoute,
} as any)
const AppWorksWorkIdRoute = AppWorksWorkIdRouteImport.update({
  id: '/works/$workId',
  path: '/works/$workId',
  getParentRoute: () => AppRoute,
} as any)
const MarketingLegalTermsRoute = MarketingLegalTermsRouteImport.update({
  id: '/legal/terms',
  path: '/legal/terms',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingLegalPrivacyRoute = MarketingLegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => MarketingRoute,
} as any)
const AppWorksWorkIdTransferRoute = AppWorksWorkIdTransferRouteImport.update({
  id: '/transfer',
  path: '/transfer',
  getParentRoute: () => AppWorksWorkIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/admin': typeof AdminRoute
  '/app': typeof AppRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/about': typeof MarketingAboutRoute
  '/faq': typeof MarketingFaqRoute
  '/for-artists': typeof MarketingForArtistsRoute
  '/for-auction-houses': typeof MarketingForAuctionHousesRoute
  '/for-galleries': typeof MarketingForGalleriesRoute
  '/pricing': typeof MarketingPricingRoute
  '/security': typeof MarketingSecurityRoute
  '/app/profile': typeof AppProfileRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/$invitationToken': typeof InviteInvitationTokenRoute
  '/proof/$proofToken': typeof ProofProofTokenRoute
  '/verify/$tagToken': typeof VerifyTagTokenRoute
  '/work/$publicWorkId': typeof WorkPublicWorkIdRoute
  '/app/': typeof AppIndexRoute
  '/verify/': typeof VerifyIndexRoute
  '/legal/privacy': typeof MarketingLegalPrivacyRoute
  '/legal/terms': typeof MarketingLegalTermsRoute
  '/app/works/$workId': typeof AppWorksWorkIdRouteWithChildren
  '/app/works/register': typeof AppWorksRegisterRoute
  '/app/transfers/': typeof AppTransfersIndexRoute
  '/app/works/': typeof AppWorksIndexRoute
  '/app/works/$workId/transfer': typeof AppWorksWorkIdTransferRoute
}
export interface FileRoutesByTo {
  '/admin': typeof AdminRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/about': typeof MarketingAboutRoute
  '/faq': typeof MarketingFaqRoute
  '/for-artists': typeof MarketingForArtistsRoute
  '/for-auction-houses': typeof MarketingForAuctionHousesRoute
  '/for-galleries': typeof MarketingForGalleriesRoute
  '/pricing': typeof MarketingPricingRoute
  '/security': typeof MarketingSecurityRoute
  '/app/profile': typeof AppProfileRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/$invitationToken': typeof InviteInvitationTokenRoute
  '/proof/$proofToken': typeof ProofProofTokenRoute
  '/verify/$tagToken': typeof VerifyTagTokenRoute
  '/work/$publicWorkId': typeof WorkPublicWorkIdRoute
  '/': typeof MarketingIndexRoute
  '/app': typeof AppIndexRoute
  '/verify': typeof VerifyIndexRoute
  '/legal/privacy': typeof MarketingLegalPrivacyRoute
  '/legal/terms': typeof MarketingLegalTermsRoute
  '/app/works/$workId': typeof AppWorksWorkIdRouteWithChildren
  '/app/works/register': typeof AppWorksRegisterRoute
  '/app/transfers': typeof AppTransfersIndexRoute
  '/app/works': typeof AppWorksIndexRoute
  '/app/works/$workId/transfer': typeof AppWorksWorkIdTransferRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_marketing': typeof MarketingRouteWithChildren
  '/admin': typeof AdminRoute
  '/app': typeof AppRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_marketing/about': typeof MarketingAboutRoute
  '/_marketing/faq': typeof MarketingFaqRoute
  '/_marketing/for-artists': typeof MarketingForArtistsRoute
  '/_marketing/for-auction-houses': typeof MarketingForAuctionHousesRoute
  '/_marketing/for-galleries': typeof MarketingForGalleriesRoute
  '/_marketing/pricing': typeof MarketingPricingRoute
  '/_marketing/security': typeof MarketingSecurityRoute
  '/app/profile': typeof AppProfileRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/$invitationToken': typeof InviteInvitationTokenRoute
  '/proof/$proofToken': typeof ProofProofTokenRoute
  '/verify/$tagToken': typeof VerifyTagTokenRoute
  '/work/$publicWorkId': typeof WorkPublicWorkIdRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/app/': typeof AppIndexRoute
  '/verify/': typeof VerifyIndexRoute
  '/_marketing/legal/privacy': typeof MarketingLegalPrivacyRoute
  '/_marketing/legal/terms': typeof MarketingLegalTermsRoute
  '/app/works/$workId': typeof AppWorksWorkIdRouteWithChildren
  '/app/works/register': typeof AppWorksRegisterRoute
  '/app/transfers/': typeof AppTransfersIndexRoute
  '/app/works/': typeof AppWorksIndexRoute
  '/app/works/$workId/transfer': typeof AppWorksWorkIdTransferRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/sign-in'
    | '/sign-up'
    | '/about'
    | '/faq'
    | '/for-artists'
    | '/for-auction-houses'
    | '/for-galleries'
    | '/pricing'
    | '/security'
    | '/app/profile'
    | '/auth/callback'
    | '/invite/$invitationToken'
    | '/proof/$proofToken'
    | '/verify/$tagToken'
    | '/work/$publicWorkId'
    | '/app/'
    | '/verify/'
    | '/legal/privacy'
    | '/legal/terms'
    | '/app/works/$workId'
    | '/app/works/register'
    | '/app/transfers/'
    | '/app/works/'
    | '/app/works/$workId/transfer'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin'
    | '/sign-in'
    | '/sign-up'
    | '/about'
    | '/faq'
    | '/for-artists'
    | '/for-auction-houses'
    | '/for-galleries'
    | '/pricing'
    | '/security'
    | '/app/profile'
    | '/auth/callback'
    | '/invite/$invitationToken'
    | '/proof/$proofToken'
    | '/verify/$tagToken'
    | '/work/$publicWorkId'
    | '/'
    | '/app'
    | '/verify'
    | '/legal/privacy'
    | '/legal/terms'
    | '/app/works/$workId'
    | '/app/works/register'
    | '/app/transfers'
    | '/app/works'
    | '/app/works/$workId/transfer'
  id:
    | '__root__'
    | '/_marketing'
    | '/admin'
    | '/app'
    | '/sign-in'
    | '/sign-up'
    | '/_marketing/about'
    | '/_marketing/faq'
    | '/_marketing/for-artists'
    | '/_marketing/for-auction-houses'
    | '/_marketing/for-galleries'
    | '/_marketing/pricing'
    | '/_marketing/security'
    | '/app/profile'
    | '/auth/callback'
    | '/invite/$invitationToken'
    | '/proof/$proofToken'
    | '/verify/$tagToken'
    | '/work/$publicWorkId'
    | '/_marketing/'
    | '/app/'
    | '/verify/'
    | '/_marketing/legal/privacy'
    | '/_marketing/legal/terms'
    | '/app/works/$workId'
    | '/app/works/register'
    | '/app/transfers/'
    | '/app/works/'
    | '/app/works/$workId/transfer'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MarketingRoute: typeof MarketingRouteWithChildren
  AdminRoute: typeof AdminRoute
  AppRoute: typeof AppRouteWithChildren
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  InviteInvitationTokenRoute: typeof InviteInvitationTokenRoute
  ProofProofTokenRoute: typeof ProofProofTokenRoute
  VerifyTagTokenRoute: typeof VerifyTagTokenRoute
  WorkPublicWorkIdRoute: typeof WorkPublicWorkIdRoute
  VerifyIndexRoute: typeof VerifyIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/': {
      id: '/verify/'
      path: '/verify'
      fullPath: '/verify/'
      preLoaderRoute: typeof VerifyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/work/$publicWorkId': {
      id: '/work/$publicWorkId'
      path: '/work/$publicWorkId'
      fullPath: '/work/$publicWorkId'
      preLoaderRoute: typeof WorkPublicWorkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/$tagToken': {
      id: '/verify/$tagToken'
      path: '/verify/$tagToken'
      fullPath: '/verify/$tagToken'
      preLoaderRoute: typeof VerifyTagTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proof/$proofToken': {
      id: '/proof/$proofToken'
      path: '/proof/$proofToken'
      fullPath: '/proof/$proofToken'
      preLoaderRoute: typeof ProofProofTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$invitationToken': {
      id: '/invite/$invitationToken'
      path: '/invite/$invitationToken'
      fullPath: '/invite/$invitationToken'
      preLoaderRoute: typeof InviteInvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_marketing/security': {
      id: '/_marketing/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof MarketingSecurityRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/pricing': {
      id: '/_marketing/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof MarketingPricingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/for-galleries': {
      id: '/_marketing/for-galleries'
      path: '/for-galleries'
      fullPath: '/for-galleries'
      preLoaderRoute: typeof MarketingForGalleriesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/for-auction-houses': {
      id: '/_marketing/for-auction-houses'
      path: '/for-auction-houses'
      fullPath: '/for-auction-houses'
      preLoaderRoute: typeof MarketingForAuctionHousesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/for-artists': {
      id: '/_marketing/for-artists'
      path: '/for-artists'
      fullPath: '/for-artists'
      preLoaderRoute: typeof MarketingForArtistsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/faq': {
      id: '/_marketing/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof MarketingFaqRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/about': {
      id: '/_marketing/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof MarketingAboutRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/app/works/': {
      id: '/app/works/'
      path: '/works'
      fullPath: '/app/works/'
      preLoaderRoute: typeof AppWorksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/transfers/': {
      id: '/app/transfers/'
      path: '/transfers'
      fullPath: '/app/transfers/'
      preLoaderRoute: typeof AppTransfersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/works/register': {
      id: '/app/works/register'
      path: '/works/register'
      fullPath: '/app/works/register'
      preLoaderRoute: typeof AppWorksRegisterRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/works/$workId': {
      id: '/app/works/$workId'
      path: '/works/$workId'
      fullPath: '/app/works/$workId'
      preLoaderRoute: typeof AppWorksWorkIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_marketing/legal/terms': {
      id: '/_marketing/legal/terms'
      path: '/legal/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof MarketingLegalTermsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/legal/privacy': {
      id: '/_marketing/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof MarketingLegalPrivacyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/app/works/$workId/transfer': {
      id: '/app/works/$workId/transfer'
      path: '/transfer'
      fullPath: '/app/works/$workId/transfer'
      preLoaderRoute: typeof AppWorksWorkIdTransferRouteImport
      parentRoute: typeof AppWorksWorkIdRoute
    }
  }
}

interface MarketingRouteChildren {
  MarketingAboutRoute: typeof MarketingAboutRoute
  MarketingFaqRoute: typeof MarketingFaqRoute
  MarketingForArtistsRoute: typeof MarketingForArtistsRoute
  MarketingForAuctionHousesRoute: typeof MarketingForAuctionHousesRoute
  MarketingForGalleriesRoute: typeof MarketingForGalleriesRoute
  MarketingPricingRoute: typeof MarketingPricingRoute
  MarketingSecurityRoute: typeof MarketingSecurityRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  MarketingLegalPrivacyRoute: typeof MarketingLegalPrivacyRoute
  MarketingLegalTermsRoute: typeof MarketingLegalTermsRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingAboutRoute: MarketingAboutRoute,
  MarketingFaqRoute: MarketingFaqRoute,
  MarketingForArtistsRoute: MarketingForArtistsRoute,
  MarketingForAuctionHousesRoute: MarketingForAuctionHousesRoute,
  MarketingForGalleriesRoute: MarketingForGalleriesRoute,
  MarketingPricingRoute: MarketingPricingRoute,
  MarketingSecurityRoute: MarketingSecurityRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  MarketingLegalPrivacyRoute: MarketingLegalPrivacyRoute,
  MarketingLegalTermsRoute: MarketingLegalTermsRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

interface AppWorksWorkIdRouteChildren {
  AppWorksWorkIdTransferRoute: typeof AppWorksWorkIdTransferRoute
}

const AppWorksWorkIdRouteChildren: AppWorksWorkIdRouteChildren = {
  AppWorksWorkIdTransferRoute: AppWorksWorkIdTransferRoute,
}

const AppWorksWorkIdRouteWithChildren = AppWorksWorkIdRoute._addFileChildren(
  AppWorksWorkIdRouteChildren,
)

interface AppRouteChildren {
  AppProfileRoute: typeof AppProfileRoute
  AppIndexRoute: typeof AppIndexRoute
  AppWorksWorkIdRoute: typeof AppWorksWorkIdRouteWithChildren
  AppWorksRegisterRoute: typeof AppWorksRegisterRoute
  AppTransfersIndexRoute: typeof AppTransfersIndexRoute
  AppWorksIndexRoute: typeof AppWorksIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProfileRoute: AppProfileRoute,
  AppIndexRoute: AppIndexRoute,
  AppWorksWorkIdRoute: AppWorksWorkIdRouteWithChildren,
  AppWorksRegisterRoute: AppWorksRegisterRoute,
  AppTransfersIndexRoute: AppTransfersIndexRoute,
  AppWorksIndexRoute: AppWorksIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  MarketingRoute: MarketingRouteWithChildren,
  AdminRoute: AdminRoute,
  AppRoute: AppRouteWithChildren,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  InviteInvitationTokenRoute: InviteInvitationTokenRoute,
  ProofProofTokenRoute: ProofProofTokenRoute,
  VerifyTagTokenRoute: VerifyTagTokenRoute,
  WorkPublicWorkIdRoute: WorkPublicWorkIdRoute,
  VerifyIndexRoute: VerifyIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
